import React from "react"
import PropTypes from "prop-types"

const Processing = props => {
  Processing.propTypes = {
    message: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    progress: PropTypes.shape({
      current: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired
    }),
    updatedAtDescription: PropTypes.string,
    updatedAtFormatted: PropTypes.string
  }

  const percent =
    props.progress?.total > 0
      ? Math.round((props.progress.current / props.progress.total) * 100)
      : 0

  return (
    <li
      className="p-4 flex flex-col flex-auto gap-2"
      data-status={props.status}
    >
      <header>
        <p className="message flex flex-row flex-auto text-sm text-gray-700 font-semibold items-center">
          {props.message}
        </p>
        {props.updatedAtDescription && (
          <p title={props.updatedAtFormatted} className="text-xs text-gray-700">
            {props.updatedAtDescription} ago
          </p>
        )}
      </header>
      <div className="h-2 w-full overflow-hidden rounded-full bg-gray-200">
        <div
          className="h-full rounded-full bg-green-400 transition-[width] duration-300 ease-out"
          style={{ width: `${percent}%` }}
        />
      </div>
    </li>
  )
}

export { Processing }
